import StatusPill, { type Tone } from '@/components/console/status-pill';
import type { ProvisioningStatus } from '@/types/platform';

const LABELS: Record<ProvisioningStatus, { text: string; tone: Tone }> = {
  pending: { text: 'Setting up', tone: 'info' },
  running: { text: 'Setting up', tone: 'info' },
  succeeded: { text: 'Ready', tone: 'success' },
  failed: { text: 'Setup failed', tone: 'danger' },
  halted: { text: 'Setup stopped', tone: 'danger' },
};

// Where an app's setup stands, in the words the owner sees.
const SetupStatusPill = ({ status }: { status: ProvisioningStatus }) => {
  const { text, tone } = LABELS[status];

  return <StatusPill tone={tone}>{text}</StatusPill>;
};

export default SetupStatusPill;
